import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest
} from '@angular/common/http';
import { AuthenticationService } from '../app/authentication/_services/authentication.service';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LogoutModalComponent } from './modaltemplate/modal.component';

/** Pass untouched request through to the next request handler. */
@Injectable()
export class HandlerInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private cookieService: CookieService,
    private modalService: NgbModal
  ) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // 每次連線判斷有無Cookie
    if (!this.cookieService.check('SESSIONID')) {
      // 刪除使用者資訊
      localStorage.removeItem('currentUser');
      // 強制轉回登入頁面
      this.router.navigate(['/authentication/login']);
    }
    // 已有登入資訊
    if (this.authenticationService.currentUserValue) {
      const projects = this.authenticationService.currentUserValue;
      const httpRequest = new HttpRequest(
        <any>req.method,
        projects['project_info'][projects['client_info']['now']]['api_url'] +
          req.urlWithParams,
        <any>req.body
      );
      req = Object.assign(req, httpRequest);
    } else {
      // 無登入資訊，強制轉回登入頁面
      this.router.navigate(['/authentication/login']);
    }
    // 每次連線附加token
    let authReq;
    const apiurl = new URL(req.url).searchParams;
    if (apiurl.get('apidl') == 'product') {
      authReq = req.clone({
        headers: req.headers
          .set('Authorization', this.cookieService.get('SESSIONID'))
          .set('Content-Type', 'application/x-www-form-urlencoded'),
        responseType: 'blob',
        reportProgress: true
      });
    } else if (apiurl.get('apidl') == 'order') {
      authReq = req.clone({
        url: req.url.split('?')[0],
        headers: req.headers.set(
          'Authorization',
          this.cookieService.get('SESSIONID')
        ),
        responseType: 'blob',
        reportProgress: true
      });
    } else {
      authReq = req.clone({
        headers: req.headers.set(
          'Authorization',
          this.cookieService.get('SESSIONID')
        )
      });
    }
    return next.handle(authReq).pipe(
      // 連線發生錯誤
      catchError((err) => {
        // token錯誤，登出
        if (err.status === 401) {
          this.authenticationService.logout();
          // 彈出確認視窗
          const modal = this.modalService.open(LogoutModalComponent, {
            size: 'sm',
            centered: true,
            backdrop: 'static'
          });
          modal.componentInstance.title = '驗證錯誤';
          modal.componentInstance.body = '轉跳回登入頁面';
        }
        return throwError(err);
      })
    );
  }
}
